import { render, staticRenderFns } from "./CorrespondenceLetterCreate.vue?vue&type=template&id=8d68e5a6&scoped=true"
import script from "./CorrespondenceLetterCreate.vue?vue&type=script&lang=js"
export * from "./CorrespondenceLetterCreate.vue?vue&type=script&lang=js"
import style0 from "./CorrespondenceLetterCreate.vue?vue&type=style&index=0&id=8d68e5a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d68e5a6",
  null
  
)

export default component.exports